import FieldFactory from "./Field.js"
import { useState, useEffect } from "react"
/*
*
* Basicamente regresa un objeto que se hace responsable de todo el funcionamiento del formulario
* Se debe llamar esta fucnion en el componente que conteien todos los fields que se quieran tener en una misma verificacion.
*
* La funcion createField del objeto que regresa inicializa un <input> o <select> en el siguiente formado
* <div class=outerDivClass>
*    <div class=innerDivFieldClass>
*        <input class=innerFieldClass />
*    </div>
*    <div class=innerDivWarClass>
*        <span class=innerWarningClass/>
*    </div>
* </div>
*
* Los estilos se pueden agregar en el componente que se llama la funcion createField, si es necesario se puede pasar
* un nombre de clase o id al div o al componente para realizar los estilos, outerDivClass, innerDivFieldClass, innerFieldClass, innerDivWarClass, e innerWarningClass .
* Se pueden agregar utilizando el ... o Object.assign() dentro dle objeto, ejemplo (este array se usaria como paramentro en FormFactory): 
*  
*
[
    {name: "edad", type: "texto", constraints: ["null", "number", ">17" ], placeholder: "ingresar edad", label: "Edad", outerDivClass: "clase", innerFieldClass: "test"}
]
*
*
* Se puede agrear formato al input agregando un valor dentro del objeto del array ejemplo:
*
* {name: "dinero", type: "texto", requirements: ["null", ">1000", "number"],, placeholder: "Ingresar monto", label: "Ingresar Monto", format: "dinero"},
*
* Soportados, dinero
*
* @param {Array} fieldsToLink Array de objetos con formato requerido {name: string, type: string, requirements: array, placeholder: string, label: string} 
*                             a ligar a un form para verificar
*
* @returns {Object} regresa un objeto para revisar si el formulario completa esta listo con .isReady() y conseguir fields individuales con getField()
*
* ejemplo :
let form1 = FormFactory([
  {name: "edad", type: "texto", requirements: ["null", ">17", "number"], placeholder: "ingresar edad", label: "Edad"},
  {name: "correo", type: "texto", requirements: ["null", "email"],  placeholder: "ingresar correo", label: "Correo electronico"},
  {name: "rfc", type: "texto", requirements: ["null", "RFC"],  placeholder: "ingresarRFC", label: "RFC"}
])
*/

const FormFactory = (fieldsToLink, variables = {}, functions = {}) => {
    const [ready, setReady] = useState(false)
    let fields = {}
    let checkValidation = () => {
        let flag = true;
        for (var key in fields) {
            if (!fields[key].isReady()) {
                flag = false;
            }
        }
        setReady(flag);
    }
    let that = () => {
        return {
            setCurp(curp){
                variables["checkpointStatus"].clave_curp = curp;
            },
            setEmail(email){
                variables["checkpointStatus"].email = email;
            },
            getField(name) {
                return fields[name]
            },
            getVariable(name) {
                // console.log(variables, name)
                return variables[name]
            },
            getFunction(name) {
                return functions[name]
            }
        }
    }
    fieldsToLink.forEach((item) => {
        let field = FieldFactory(item, checkValidation, that)
        fields[item.name] = (field)
    })

    let informParent = (state) => { }
    useEffect(() => {
        informParent(ready);
    }, [ready]);

    return {
        clear() {
            Object.keys(fields).map(fld => {
                fields[fld].clear();
            })
        },
        setInformParent(fn) {
            informParent = fn;
        },
        isReady() {
            return ready;
        },
        getField(name) {
            return fields[name];
        },
        getMissing() {
            // console.log(fields)
            Object.keys(fields).map(key => {
                // console.log(fields[key].getValue())
                fields[key].checkField(true)
            })
        },
        printMissing() {
            // console.log(fields)
            Object.keys(fields).map(key => {
                if (!fields[key].getValue()) {
                    // console.log("missing field",key)
                }
            })
        },
        getFields() {
            return fields;
        },
    }
}

export default FormFactory
